<template>
    <v-container>
        <h1 class="titulo mb-3">Configuração de Grupos Exclusivos</h1>
        <v-card class="card">
            <v-card-text>
                <m-form ref="form">
                    <v-row>
                        <v-col cols="6" md="4">
                            <m-text-field label="Informe o código do grupo: " class="required"
                                          v-input-filter="[$filters.numeric]" maxlength="8" v-model="gruposLocais.cd_grupo"
                                          outlined :rules="[$rules.required]" v-uppercase />
                        </v-col>
                        <v-col cols="6" md="4">
                            <DynamicSelect label="Selecione o(s) P.V(s):" id="SelectPontoVenda"
                                           v-model="gruposLocais.pontos_venda" :items="dadosGruposLocais.pontos_venda"
                                           endpoint="/dynamic-selects/pontos_venda/id" :multiple="true" />
                        </v-col>
                        <v-col cols="6" md="4">
                            <v-autocomplete label="Selecione a Unidade de Negócio:" id="SelectUnidadeNegocio"
                                            item-text="label" item-value="value" outlined clearable
                                            :items="dadosGruposLocais.unidades_negocio" v-model="gruposLocais.id_unidade_negocio" />
                        </v-col>
                        <v-col cols="6" md="4">
                            <v-select label="Selecione a Marca:" id="SelectMarca" item-text="label" item-value="value"
                                      outlined clearable :items="dadosGruposLocais.marcas" v-model="gruposLocais.id_marca" />
                        </v-col>
                        <v-col cols="6" md="4">
                            <HintMessage style="max-width: 500px;" class="mt-8 mb-5" title="DICA PARA CONFIGURAÇÃO"
                                         icon="mdi-lightbulb-on-outline" icon-color="secondary"
                                         description="<p>Não esqueça de incluir os <strong>zeros à esquerda</strong> de cada grupo configurado.</p> <p>Os grupos inseridos poderão ser visualizados e comercializados <strong>apenas para as entidades</strong> parametrizadas nessa tela.</p>"
                                         :description-html="true"
                                         :center-icon="true" />
                        </v-col>
                    </v-row>
                    <v-row class="mb-6">
                        <v-col cols="12" class="d-flex justify-end">
                            <v-btn class="transition" color="primary" rounded @click="inserir">
                                Salvar
                            </v-btn>
                        </v-col>
                    </v-row>
                </m-form>
                <v-layout class="d-flex justify-space-between flex-wrap">
                    <v-btn class="transition ml-1" color="primary" rounded @click="toggleFiltro">
                        <v-icon small style="margin-right: 10px;">rod-filter</v-icon>
                        Filtrar por:
                        <v-icon :class="{ 'rotate90': filter_open }" small>chevron_right</v-icon>
                    </v-btn>
                    <v-btn class="transition mr-1" color="primary" rounded @click="exportarExcel">
                        <v-icon left size="18">
                            mdi-file-chart
                        </v-icon>
                        Salvar Relatório
                    </v-btn>
                </v-layout>
                <collapse-transition>
                    <m-form ref="filter" v-show="filter_open" class="mt-4 ml-2">
                        <v-row>
                            <v-col cols="6">
                                <m-text-field outlined label="Código do grupo:" v-input-filter="[$filters.numeric]"
                                              v-model="filters.cd_grupo" v-uppercase />
                            </v-col>
                            <v-col cols="6">
                                <v-autocomplete label="Un. Negócio:" id="SelectFilterUnidadeNegocio" item-text="label"
                                                item-value="value" outlined clearable :items="dadosGruposLocais.unidades_negocio"
                                                v-model="filters.id_unidade_negocio" />
                            </v-col>
                            <v-col cols="6">
                                <DynamicSelect label="Selecione o(s) P.V(s):" id="SelectPontoVenda"
                                               v-model="filters.pontos_venda" :items="dadosGruposLocais.pontos_venda"
                                               endpoint="/dynamic-selects/pontos_venda/id" :multiple="false" />
                            </v-col>
                            <v-col cols="6">
                                <v-select label="Marca:" id="SelectFilterMarca" item-text="label" item-value="value"
                                          outlined clearable :items="dadosGruposLocais.marcas" v-model="filters.id_marca" />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" class="d-flex justify-start">
                                <v-btn color="secondary" @click="limpar">
                                    Limpar
                                </v-btn>
                            </v-col>
                            <v-col cols="6" class="d-flex justify-end">
                                <v-btn color="primary" @click="filtrar">
                                    Filtrar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </m-form>
                </collapse-transition>
                <DataTable ref="datatable" url="/painel/grupos_locais/listar" class="pt-2 data-table-overlow"
                           :headers="headers" :params="params" :filter="dtFiltro">
                    <template v-slot:items="{item}">
                        <td class="text-center">
                            <v-menu :close-on-content-click="false">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn color="primary" class="btn-acoes" v-bind="attrs" v-on="on">
                                        <v-icon>mdi-dots-horizontal</v-icon>
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item>
                                        <v-list-item-title class="font-weight-bold">
                                            O que deseja fazer?
                                        </v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="editar(item)">
                                        <v-list-item-title>Editar</v-list-item-title>
                                    </v-list-item>
                                    <v-list-item @click="confirmExcluir(item.id)">
                                        <v-list-item-title>Excluir</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </td>
                        <td class="text-center">{{ item.cd_grupo }}</td>
                        <td class="text-center" style="max-width: 300px;">
                            <div class="pv-container">
                                <div style="width: 20px;">
                                    <div v-if="exibirIconePv(item)" class="d-flex justify-center align-center">
                                        <v-tooltip bottom offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-icon size="16" v-on="on" color="primary">mdi-help-box</v-icon>
                                            </template>
                                            <span>Não foi possível buscar as informações do(s) P.V.(s), portanto será
                                                exibido o ID do(s)
                                                mesmo(s).</span>
                                        </v-tooltip>
                                    </div>
                                </div>
                                <div class="d-flex" style="max-width: 100%; flex-wrap: wrap; justify-content: center;">
                                    <div v-for="(pv, index) in getPv(item)" :key="index"
                                         class="text-center pv-span ma-1">
                                        {{ pv }}
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td class="text-center">{{ getUnidade(item.unidade) }}</td>
                        <td class="text-center">{{ getFlavor(item.flavor) }}</td>
                    </template>
                </DataTable>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import { notification } from '@/plugins/helpers'
  import { AlertTypes } from '../../../plugins/alerts_types'
  import { alert } from '../../../plugins/helpers'
  import * as Qs from 'qs'

  export default {
    name: 'GruposLocais',
    data: () => ({
      filter_open: false,
      pagination: {
        sortBy: [], descending: []
      },
      dtFiltro: {},
      gruposLocais: {
        cd_grupo: '',
        pontos_venda: [],
        id_unidade_negocio: null,
        id_marca: null
      },
      dadosGruposLocais: {
        marcas: [],
        unidades_negocio: [],
        pontos_venda: ''
      },
      headers: [
        { text: 'Ações', value: '', align: 'center', sortable: false },
        { text: 'Código do grupo', value: 'cd_grupo', align: 'center', sortable: true },
        { text: 'P.V(s)', value: 'pontos_venda', align: 'center', sortable: true },
        { text: 'Unidade de Negócio ', value: 'id_unidade_negocio', align: 'center', sortable: true },
        { text: 'Marca ', value: 'id_marca', align: 'center', sortable: true }
      ],
      filters: {
        cd_grupo: '',
        id_unidade_negocio: '',
        id_marca: '',
        pontos_venda: ''
      }
    }),
    computed: {
      params () {
        return { pagination: this.pagination, include: ['flavor', 'unidade'] }
      },
      unidades () {
        return this.$session.get('unidades').map(unidade => ({ value: unidade.id_unidade_negocio, label: `${unidade.cd_unidade_negocio} - ${unidade.nm_unidade_negocio}` }))
      }
    },
    async mounted () {
      await this.getInputsData()
    },
    methods: {
      getFlavor (flavor) {
        if (flavor) {
          return flavor.nome_amigavel
        } else {
          return '-'
        }
      },
      getUnidade (unidade) {
        if (unidade) {
          return unidade.cd_unidade_negocio + ' - ' + unidade.nm_unidade_negocio
        } else {
          return '-'
        }
      },
      exibirIconePv (item) {
        return item.pontos_venda && (!item.nm_pontos_venda || item.nm_pontos_venda.length === 0)
      },
      getPv (item) {
        if (item.nm_pontos_venda && item.nm_pontos_venda.length > 0) {
          return item.nm_pontos_venda
        } else if (item.pontos_venda) {
          return item.pontos_venda.split(',')
        } else {
          return ['-']
        }
      },
      async getInputsData () {
        const getMarcas = this.getMarcas()
        this.dadosGruposLocais.unidades_negocio = this.unidades
        return Promise.all([getMarcas])
      },
      async getMarcas () {
        return new Promise((resolve, reject) => {
          this.$http.get('/painel/flavors/get-all-formatados')
            .then((response) => {
              this.dadosGruposLocais.marcas = response.data.flavors
              resolve()
            })
            .catch((error) => {
              notification('error', 'Prezado parceiro, ocorreu um erro ao carregar as marcas, sugerimos recarregar a página e caso o erro persista entre em contato com a Área de Suporte.')
              reject(error)
            })
        })
      },
      async saveGrupoLocal (http, payload, id = null) {
        if (id) {
          return http.put(`/painel/grupos_locais/editar/${id}`, payload)
        }
        return http.post('/painel/grupos_locais/inserir', payload)
      },
      async editar (item) {
        this.gruposLocais = {
          cd_grupo: item.cd_grupo,
          pontos_venda: item.pontos_venda ? item.pontos_venda.split(',').map(id => parseInt(id)) : [],
          id_unidade_negocio: item.id_unidade_negocio,
          id_marca: item.id_marca,
          id: item.id
        }

        try {
          if (!this.dadosGruposLocais.unidades_negocio.length) {
            this.dadosGruposLocais.unidades_negocio = this.unidades
          }

          const unidadeSelecionada = this.dadosGruposLocais.unidades_negocio.find(
            unidade => unidade.value === parseInt(item.id_unidade_negocio)
          )
          if (unidadeSelecionada) {
            this.gruposLocais.id_unidade_negocio = unidadeSelecionada.value
          }

          const selectedPvs = item.pontos_venda
            ? item.pontos_venda.split(',').map(id => parseInt(id))
            : []
          this.gruposLocais.pontos_venda = selectedPvs

          this.dadosGruposLocais.pontos_venda = selectedPvs.map(id => ({ id }))
        } catch (error) {
          notification(AlertTypes.ERROR, 'Erro ao carregar os pontos de venda para edição.')
        }

        this.$refs.form.resetValidation()
      },
      async confirmExcluir (id) {
        alert({
          text: `Tem certeza que deseja excluir a configuração do grupo exclusivo?`,
          buttons: {
            'Cancelar': () => true,
            'Confirmar': async () => {
              try {
                await this.$http.delete(`/painel/grupos_locais/excluir/${id}`)
                notification(AlertTypes.SUCCESS, 'Configuração de grupos exclusivos excluída com sucesso!')
                this.$refs.datatable.reload()
              } catch (error) {
                notification(AlertTypes.ERROR, `Não foi possível excluir a configuração no momento. Erro: ${error.response?.data?.error || error.message}`)
              }
            }
          }
        })
      },
      exportarExcel () {
        const filtros = { ...this.filters }

        const encoded_params = Qs.stringify({
          filter: filtros,
          pagination: { sortBy: this.params.pagination.sortBy, descending: this.params.pagination.descending },
          headers: this.headers.map(header => header.value),
          headers_formatado: this.headers.map(header => header.text)
        }, {
          arrayFormat: 'brackets',
          encode: true
        })
        window.open(`${this.ws}/grupos_locais/exportar?${encoded_params}`)
      },
      async inserir () {
        if (!this.gruposLocais.cd_grupo) {
          notification(AlertTypes.WARN, 'O campo "Código do Grupo" é obrigatório.')
          return
        }

        if (this.gruposLocais.cd_grupo &&
          (!this.gruposLocais.pontos_venda.length &&
            !this.gruposLocais.id_unidade_negocio &&
            !this.gruposLocais.id_marca)) {
          notification(AlertTypes.WARN, 'Preencha pelo menos um campo além do código do grupo.')
          return
        }

        try {
          const payload = {
            cd_grupo: this.gruposLocais.cd_grupo,
            pontos_venda: this.gruposLocais.pontos_venda,
            id_unidade_negocio: this.gruposLocais.id_unidade_negocio,
            id_marca: this.gruposLocais.id_marca
          }

          if (this.gruposLocais.id) {
            await this.saveGrupoLocal(this.$http, payload, this.gruposLocais.id)
            notification(AlertTypes.SUCCESS, 'Configuração de grupos exclusivos atualizada com sucesso!')
          } else {
            await this.saveGrupoLocal(this.$http, payload)
            notification(AlertTypes.SUCCESS, 'Configurações de grupos exclusivos salvas com sucesso!')
          }

          this.resetForm()
          this.$refs.datatable.reload()
        } catch (error) {
          notification(AlertTypes.ERROR, `${error.response?.data?.error || error.message}`)
        }
      },
      resetForm () {
        this.gruposLocais = {
          cd_grupo: '',
          pontos_venda: [],
          id_unidade_negocio: null,
          id_marca: null
        }
        this.$refs.form.resetValidation()
      },
      toggleFiltro () {
        this.filter_open = !this.filter_open
      },
      filtrar () {
        if (this.$refs.filter.validate()) {
          const filtros = { ...this.filters }
          this.dtFiltro = filtros
        }
      },
      limpar () {
        this.filters = {
          cd_grupo: '',
          pontos_venda: '',
          id_unidade_negocio: '',
          id_marca: ''
        }

        this.filtrar()
        this.filter_open = false
      }
    }
  }
</script>

<style scoped>
.pv-container {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 0;
    margin: 0 auto;
    width: 100%;
}

.pv-span {
    background-color: #ebe9e9;
    color: #333333;
    padding: 10px 12px;
    border-radius: 16px;
    text-align: center;
    box-sizing: border-box;
    word-break: keep-all;
    width: fit-content;
    font-size: 14px;
    line-height: 1.4;
    font-weight: 500;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    transition: all 0.2s ease-in-out;
}

.pv-span:hover {
    background-color: #d6d4d4;
    transform: scale(1.05);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.v-btn:not(.v-btn--round).v-size--default.btn-acoes {
    padding: 0px;
    min-width: 0;
    width: 48px;
    margin-right: 10px;
    margin: 5px 0;
}

</style>
